/**
 * Locations Sagas
 */

import { call, put, takeLatest } from '@ufc/core'
import { locationsActions } from './locations.slice'
import { fetchHeaderLocations } from '../infrastructure/api/locations-api'

function* fetchLocationsListSaga() {
  try {
    const locations: Awaited<ReturnType<typeof fetchHeaderLocations>> = yield call(fetchHeaderLocations)
    yield put(locationsActions.fetchLocationsListSuccess(locations))
  } catch (error: any) {
    yield put(locationsActions.fetchLocationsListFailure(error?.message ?? 'Failed to fetch locations'))
  }
}

export function* locationsSaga() {
  yield takeLatest(locationsActions.fetchLocationsList.type, fetchLocationsListSaga)
}
